import { render, staticRenderFns } from "./f_pencatatan_perceraian.vue?vue&type=template&id=905b6ba4&"
import script from "./f_pencatatan_perceraian.vue?vue&type=script&lang=js&"
export * from "./f_pencatatan_perceraian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QBtn,QInput,QMarkupTable,QItem,QItemSection,QItemLabel,QBadge,QExpansionItem,QList,QIcon,QSpinnerPie,QPagination,QSpinnerFacebook,QDialog,QCardActions,QSelect,QBanner,QRadio,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QBtn,QInput,QMarkupTable,QItem,QItemSection,QItemLabel,QBadge,QExpansionItem,QList,QIcon,QSpinnerPie,QPagination,QSpinnerFacebook,QDialog,QCardActions,QSelect,QBanner,QRadio})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
